import type { FC } from 'react';

import React, { memo } from 'react';
import styled from 'styled-components';

type IndicatorProps = {
  progress: number;
  width: number;
};

export const Indicator: FC<IndicatorProps> = memo((props) => {
  const { progress, width } = props;

  return (
    <Container width={width}>
      <Progress width={progress} />
    </Container>
  );
});

const Container = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
  background: rgba(255, 255, 255, 0.24);
  backdrop-filter: blur(64px);
  height: 6px;
  border-radius: ${({ theme }) => theme.borderRadius.round}px;
  overflow: hidden;
`;

const Progress = styled.div<{ width: number }>`
  width: ${({ width }) => width}%;
  height: 6px;
  border-radius: ${({ theme }) => theme.borderRadius.round}px;
  background: ${({ theme }) => theme.colors.white};
  transition: width 0.5s;
`;
